/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Slide, makeStyles, useMediaQuery,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import config from '@/configs/config';
import _ from 'lodash';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);
const useStyle = makeStyles((theme) => ({
  scrollPaper: {
    alignItems: 'flex-end',

    [theme.breakpoints.up('sm')]: {
      alignItems: 'center',
    },
  },
  paper: {
    height: 'auto',
    maxHeight: '90%',
  },
  checkoutButton: {
    background: config.themeBackgroundColor,
    borderRadius: 5,
    marginLeft: theme.spacing(3),
    color: 'white',
  },
}));

const useItemStyle = makeStyles((theme) => ({
  root: {
    '&+&': {
      marginTop: theme.spacing(2.5),
    },
  },
  productName: {
    flexShrink: 0,
  },
}));

const Item = ({ data, amount }) => {
  const classes = useItemStyle();
  const { t } = useTranslation();

  const {
    name,
    specs,
    provider,
  } = data || {};

  return (
    <div className={classes.root}>
      <div className={classes.productName}>{`${t('ec.purchase_products')}：【${provider}】${name} X ${amount}`}</div>
      {
        (specs || []).map(({ name: specName, value }) => (
          <div className={classes.productName} key={specName}>
            {`${specName}：${value}`}
          </div>
        ))
      }
    </div>
  );
};

export default ({
  data,
  isOpen,
  onClose,
  onOkbuttonClick,
}) => {
  const classes = useStyle();
  const { t } = useTranslation();
  const isUpSm = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  const fullScreen = !isUpSm;
  const hasDifferentProviders = useMemo(() => _
    .uniq((data || [])
      .map((d) => _.get(d, ['data', 'provider'], '')))
    .length !== 1,
  [data]);

  return (
    <Dialog
      classes={{
        scrollPaper: classes.scrollPaper,
        paper: classes.paper,
      }}
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      fullScreen={fullScreen}
      TransitionComponent={Transition}
    >
      <DialogTitle>
        {
          hasDifferentProviders ? (
            <div style={{ color: 'red' }}>
              {t('ec.cannot_checkout_with_different_providers')}
            </div>
          ) : t('ec.confirm_checkout')
        }

      </DialogTitle>
      <DialogContent>
        {data.map((item) => {
          const { id, amount } = item || {};
          return <Item data={item.data} amount={amount} key={id} />;
        })}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('ec.go_back_and_edit')}</Button>
        <Button
          className={classes.checkoutButton}
          variant="contained"
          onClick={onOkbuttonClick}
          disabled={hasDifferentProviders}
        >
          {t('ec.checkout')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
